import { useSearchParams } from 'react-router-dom';

// TODO: Just remove this altogether and use the useQueryParams hook directly
export const useQueryParams = () => {
  const [searchParams] = useSearchParams();

  return searchParams;
};
